import {Fragment, observer, React} from '@api'
import {useCatalogItemSidebarDetailsStore} from '@modules'
import {useCatalog} from '@stores'
import {C8MenuButton} from '@modules'
import * as css from './CatalogOpenInC8.css'


export const CatalogOpenInC8 = observer(() => {
  const { data } = useCatalogItemSidebarDetailsStore(),
    {catalogConfig: {openInC8Field,redirectToPLM}, c8} = useCatalog(),
    openInC8Value = openInC8Field ? _.get(data, openInC8Field) : null

  return openInC8Value ? <C8MenuButton className={css.c8Button} url={c8.urlForId(openInC8Value,redirectToPLM)}/> : <Fragment></Fragment>
})


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/CatalogOpenInC8.tsx